export default __webpack_public_path__ + "static/Jay Hao-b4b203bf5bf026c984c6026e5cd119d4.png";